/* eslint-disable import/no-unused-modules */
import { useDebounceCallback } from '@react-hook/debounce';
import { noop } from 'lodash';
import { useEffect, useState } from 'react';
import {
  StyledValidationError,
  StyledWithValidation
} from './ValidationError.style';
import { boolPropsToClassNames } from 'common/utils/style.utils';

export const withValidations = WrappedComponent => {
  return ({
    validationRules = [],
    valuePropName = 'value',
    onChange = noop,
    ...props
  }) => {
    const value = props[valuePropName];
    const [localValue, setLocalValue] = useState(value);
    const [validationError, setValidationError] = useState(null);

    const validate = () => {
      setValidationError(null);
      for (const rule of validationRules) {
        if (rule.condition?.(localValue)) {
          setValidationError(rule.message);
          return false;
        }
      }

      return true;
    };

    const onChangeLocalValue = useDebounceCallback(() => {
      if (validate()) {
        onChange(localValue);
      }
    }, 500);

    useEffect(() => {
      onChangeLocalValue();
    }, [localValue]);

    useEffect(() => {
      setLocalValue(value);
    }, [value]);

    return (
      <StyledWithValidation
        width={props.width}
        className={boolPropsToClassNames({ hasError: !!validationError })}
      >
        <WrappedComponent
          {...props}
          {...{ [valuePropName]: localValue }}
          onChange={setLocalValue}
        />
        {validationError && (
          <StyledValidationError>{validationError}</StyledValidationError>
        )}
      </StyledWithValidation>
    );
  };
};
